<template>
    <h3>7095报价</h3>
    <!-- 搜索表单 -->
    <SearchForm @submit="fetchData" :isSubmitting="isSubmitting" />
    <!-- 表格区域 -->
    <div v-if="tableData.length > 0" class="table-container">
         {{ths.date}}
         {{ths.now_str}}
         {{ths.stock_code}}
         {{ths.stock_name}}
         {{ths.structure}}
          <RiskyStockTable :tableData="filteredTableData" :now_str="now_str" />
    </div>


</template>

<script>
import axios from 'axios';
import SearchForm from '@/components/SearchForm.vue';
import RiskyStockTable from '@/components/RiskyStockTable.vue';

export default {
  name: 'StockSearchFormPage',
  components: {
    SearchForm,
    RiskyStockTable
  },
  data() {
    return {
      isSubmitting: false,
      date:'',
      searchQuery: '',
      stock_name:'',
      structure:'',
      stock_code:'',
      now_str:'',
      warring: '',
      tableData: [],
      originalTableData: [], // 添加原始数据副本
      selectedStructure: '100%',
      selectedStructure_amount: '1',
      selectedBrokerage: 'all', // 初始化为默认值
      containerDisplay: false
    };
  },
  computed: {
    filteredTableData() {
      let filteredData = this.tableData;
      return filteredData;
    }
  },
  methods: {

     async fetchData(searchData) {
       const { query, date } = searchData;
      if (this.isSubmitting) return;

      this.isSubmitting = true;
      try {
      // 构建请求参数，只添加存在的参数
        const params = {
          code: query
        };

        // 如果有日期则添加日期参数
        if (date) {
          params.now_date = date;
        }
        const response = await axios.get(`/api/query_risky`,{
             headers: {
                 'Authorization': `Bearer ${this.$store.getters.token}`
             },
            params

        });
        const responseData = response.data;

        if (responseData.stock_data_list == null) {
          this.$message.error(responseData.detail||'不是7095标的');
          this.data = {};
          this.tableData = [];
        } else {
          this.data = responseData;
          this.generateTableData();
          this.containerDisplay = false;
        }
      } catch (error) {
        this.warring = '数据获取失败，' + this.data.error;
      } finally {
        this.isSubmitting = false;
        console.log('请求完成');
      }
    },
      generateTableData() {
      const { date, stock_code, stock_name, stock_data_list } = this.data;
      this.now_str = this.data.now_str;
      this.scode = stock_code ? stock_code.split('.')[0] : '';

      // 确保数据存在后再进行操作
      const dataExists = stock_data_list && Object.keys(stock_data_list).length > 0;

      this.tableData = dataExists ? [
        {
          date,
          stock_code,
          stock_name,
          term: '3M',
          ...this.extractValues(stock_data_list, [2, 5,3])
        },
        {
          date: '',
          stock_code: '',
          stock_name: '',
          term: '6M',
          ...this.extractValues(stock_data_list, [3, 99,3])
        }
      ] : [];
    },
    extractValues(stock_data_list, indices) {
      console.log('indices:', indices);

      return {
        中信_7095: (stock_data_list['中信_7095'] && stock_data_list['中信_7095'][indices[1]] !== undefined)
          ? stock_data_list['中信_7095'][indices[1]]
          : 0,

        银河_7095: (stock_data_list['银河_7095'] && stock_data_list['银河_7095'][indices[0]] !== undefined)
          ? stock_data_list['银河_7095'][indices[0]]
          : 0,
          中金_7095: (stock_data_list['中金_7095'] && stock_data_list['中金_7095'][indices[2]] !== undefined)
          ? stock_data_list['中金_7095'][indices[2]]
          : 0
      };
    },

  }
};
</script>
<styled>


</styled>